import HeaderVariantLogo from './HeaderVariantLogo.component';
export default HeaderVariantLogo;